import { useEffect, useState } from "react";
import { useAutoLogout } from "../../hooks/useAutoLogout";
import styles from "./AutoLogout.module.scss";

interface AutoLogoutProps {
  onLogout: () => void;
  onInactivityLogout?: () => void;
}

export function AutoLogout({ onLogout, onInactivityLogout }: AutoLogoutProps) {
  const { showWarning, handleStayLoggedIn } = useAutoLogout({
    onLogout,
    onInactivityLogout,
  });
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    if (showWarning) {
      setCountdown(60);
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [showWarning]);

  if (!showWarning) {
    return null;
  }

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Session Timeout Warning</h2>
        <p className={styles.message}>
          You will be logged out in 1 minute due to inactivity.
        </p>
        <p className={styles.countdown}>
          Time remaining: {minutes}:{seconds.toString().padStart(2, "0")}
        </p>
        <div className={styles.buttonContainer}>
          <button
            onClick={handleStayLoggedIn}
            className={styles.primaryButton}
            type="button"
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            className={styles.secondaryButton}
            type="button"
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
}
